import { NamePrefixModifier } from 'Components/Core/InjectedPropsContext';
import { PageSection } from 'Components/Layout';
import {
  WorksheetImagesAndRemarksSection,
  WorksheetRootComponent,
  WorksheetTestedBySection,
} from 'Components/Worksheets/Core';
import AsSamplePreparationSection from 'Components/Worksheets/Shared/AS/Preparation/PreparationSection';
import ids from '../../QestIds';
import AsLiquidLimitOnePointSection from './LiquidLimit/OnePoint/LiquidLimitOnePointSection';
import { AsPlasticLimitSection } from './PlasticLimit';
import { ResultsSection } from './Sections';

const qestIds = [ids.atterbergLimit.AS_1289_3_1_2or3_2_1or3_3_1.rev2009];

let AsAtterbergLimitWorksheetOnePoint: WorksheetRootComponent = () => {
  return (
    <>
      <PageSection heading="Sample Preparation">
        <NamePrefixModifier appendNamePrefix="SamplePreparation">
          <AsSamplePreparationSection />
        </NamePrefixModifier>
      </PageSection>
      <PageSection heading="Liquid Limit (One Point Casagrande)">
        <AsLiquidLimitOnePointSection />
      </PageSection>
      <AsPlasticLimitSection />
      <PageSection>
        <WorksheetTestedBySection />
      </PageSection>
      <ResultsSection />
      <PageSection heading="Images and Remarks">
        <WorksheetImagesAndRemarksSection />
      </PageSection>
    </>
  );
};

AsAtterbergLimitWorksheetOnePoint.qestIds = qestIds;

export default AsAtterbergLimitWorksheetOnePoint;
